export function useReservationFormLoadingState() {
    return useState<boolean>('reservationFormLoading', () => false)
}
